define('drops/scrollSync/scrollSync',[
    'jquery',
    'underscore',
    'lq/drop'
], function ($, _, Drop) {
    'use strict';

    function ScrollSync(options) {
        Drop.call(this, $('<div/>'), options);

        this.$element.css({
            display: "none",
            pointerEvents: "none",
        });
    };

    Drop.extend(ScrollSync, Drop);

    ScrollSync.typeName = 'ScrollSync';

    ScrollSync.prototype.postRender = function () {
        var self = this;

        if (!this.data.syncedDrops) return;

        this.allScrollableElements = [];

        this.data.syncedDrops.map(function (syncedDrop) {
            let drop = self.piping.dropFactory.findDropByName(syncedDrop.dropName);

            switch (drop.type) {
                case "List":
                    self.allScrollableElements.push(drop.$scrollableElement);

                    if (syncedDrop.hideScrollbar) {
                        drop.$scrollableElement.addClass("scrollbar-hidden");
                    }

                    break;
            }
        })

        this.allScrollableElements.forEach(function (scrollableElement) {
            self.syncScroll(scrollableElement, self.allScrollableElements);
        });

        this.attachObserver();
    };


    ScrollSync.prototype.syncScroll = function ($element, allElements) {
        this.subscribeEventHandler($element, 'scroll', function () {
            var scrollTop = $element.scrollTop();
            allElements.forEach(function ($otherElement) {
                $otherElement.scrollTop(scrollTop);
            });
        });
    }

    ScrollSync.prototype.attachObserver = function () {
        /* 
            Observe changes to the DOM to handle dynamically added elements
            As of now this is specifically for the Gantt Chart drop, that is rendered later using React
        */
        var self = this;

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    $(mutation.addedNodes).each(function () {
                        var $newElements = $(this).find('[class*="ganttGridContentContainer"]');

                        if ($newElements.length > 0) {
                            $newElements.each(function () {
                                self.allScrollableElements.push($(this));
                                self.syncScroll($(this), self.allScrollableElements);
                            });
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    return ScrollSync;
});

